import React from 'react';
import { scrollToId } from '../services/booking';
import AlphaLoop from './objects/AlphaLoop';
import '../styles/Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="top" className="hero">
      <div className="obj-spot spot-hero" aria-hidden="true"><AlphaLoop slug="emblem" /></div>
      <div className="container hero-inner">
        <p className="hero-line hero-eyebrow">
          Sales &amp; Trading · Investment Banking · Consulting
        </p>

        <h1 className="hero-line hero-title">
          The
          <span className="hero-bracket">
            <span aria-hidden="true" className="bracket-glyph">[</span>
            <em>best</em>
            <span aria-hidden="true" className="bracket-glyph">]</span>
          </span>
          career guidance for high finance.
        </h1>

        <p className="hero-line hero-sub">
          Maximise your chances of landing your dream job.
        </p>

        <div className="hero-line hero-actions">
          <button className="btn btn-primary hero-cta" onClick={() => scrollToId('tracks')}>
            Choose your track
            <span aria-hidden="true">→</span>
          </button>
          <button className="btn btn-ghost" onClick={() => scrollToId('tutors')}>
            Meet the tutors
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
